// startup
// Load entry module and return exports
__webpack_require__(4845);
// This entry module used 'module' so it can't be inlined
__webpack_require__(1120);
__webpack_require__(7636);
__webpack_require__(8964);
var __webpack_exports__ = __webpack_require__(5345);
